function sendMessageToFrame({ payload, frame }) {
	frame.contentWindow.postMessage(payload, "*");
}

export default {
	sendMessageToFrame,
	broadcastMessage({ frames, payload }) {
		Object.values(frames).forEach(frame => sendMessageToFrame({ payload, frame }));
	}
}
